export * from "modules/DealerLocationDetails/components/Tyres/hooks/useTyreTeamCredentialsQuery";
